export const BREAKPOINTS_SIZES = {
	MOBILE: 600,
	TABLET: 960
};

export const ADAPTIVE_STATES = {
	MOBILE: 1,
	TABLET: 2,
	DESKTOP: 3
};
